export default "__VITE_ASSET__DpLrRHOq__"